import { graphql } from '@/generated/gql';

export const SOURCING_CASE_ISSUES_QUERY = graphql(/* GraphQL */ `
  query SourcingCaseIssues($id: UUID!) {
    tesseract {
      sourcingCase(id: $id) {
        id
        issues {
          id
          variant
          status
        }
      }
    }
  }
`);
